import React, { Component } from 'react'
import './home.css'
import NavArr from '../handf/nav.json'
import Footer from '../handf/Footer'
import { get, post } from '../../ajax/tools'
import PopUp from '../round/PopUp'
import Pagination from '../round/Pagination3'

class GS extends Component {
  constructor(props) {
    super(props)
    this.state = {
      SSPage: 0,
      Year: '',

      CityArr: [],
      City: '',
      CityId: '',

      ProNewsArr: [],
      ProNewsBrr: [],
      new: '',

      PageSize: 10,
      CurrentPage: 1,

      NewContent: '',
      title: '',
      Img: '',
      XQNewsArr: [],
      XQNewsBrr: [],
      newIndex: '',

      MoreCity: '',
    }
  }
  componentDidMount = function () {
    let Route = this.props.location.search
    let ThreeIndex = Route.lastIndexOf('?') //'_'最后出现的位置
    if (ThreeIndex === -1) {
      this.setState({
        SSPage: 0,
      })
    } else {
      let sb = Route.substring(ThreeIndex + 1)
      get({ url: 'match/show_pro_match_scenery_info/' + Number(sb) }).then(
        (res) => {
          if (res.errno === '200') {
            let data = res.data[0]
            this.setState({
              NewContent: data.content,
              title: data.title,
              Img: data.image_url,
            })
            let XQProvince = data.province
            post({
              url: 'match/show_pro_match_scenery_deduplication',
              data: {
                pro: XQProvince,
              },
            }).then((res) => {
              if (res.errno === '200') {
                let dsb = function () {
                  for (let i = 0; i < res.data.length; i++) {
                    let a = res.data[i].id
                    if (a === Number(sb)) {
                      return i
                    }
                  }
                }
                res.data.splice(dsb(), 1)
                this.setState({
                  XQNewsArr: res.data,
                  newIndex: dsb(),
                })
              }
            })
          } else {
            this.setState({
              NewContent: '',
              title: '',
              Img: '',
            })
          }
        }
      )
      this.setState({
        SSPage: Number(sb),
      })
    }

    get({ url: 'match/get_match_addr' }).then((res) => {
      if (res.errno === '200') {
        this.setState({
          CityArr: res.data,
          City: res.data[0].province,
        })
        post({
          url: 'match/show_pro_match_scenery_deduplication',
          data: {
            pro: res.data[0].province,
          },
        }).then((res) => {
          if (res.errno === '200') {
            let KeyStart = (this.state.CurrentPage - 1) * this.state.PageSize
            let KeyEnd = this.state.CurrentPage * this.state.PageSize
            let DownloadList = []
            if (KeyEnd <= res.data.length) {
              for (let i = KeyStart; i < KeyEnd; i++) {
                const DownloadListBrr = res.data[i]
                DownloadList.push(DownloadListBrr)
              }
            } else {
              for (let i = KeyStart; i < res.data.length; i++) {
                const DownloadListBrr = res.data[i]
                DownloadList.push(DownloadListBrr)
              }
            }
            this.setState({
              new: '1',
              ProNewsArr: res.data,
              ProNewsBrr: DownloadList,
            })
          } else {
            this.setState({
              ProNewsArr: [],
              new: '2',
            })
          }
        })
      } else {
        this.setState({
          CityArr: [],
          City: '',
        })
      }
    })

    window.onscroll = function () {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      let AllHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight
      // console.log("滚动距离" + scrollTop);
      // console.log(AllHeight - scrollTop);
      // 计算滚动条长度的函数
      let sb = document.querySelector('.YJBackTop')
      if (sb) {
        if (scrollTop > 450) {
          document.querySelector('.YJBackTop').style.display = 'block'
        } else {
          document.querySelector('.YJBackTop').style.display = 'none'
        }
        if (AllHeight - scrollTop > 500) {
          document.querySelector('.YJBackTop').style.position = 'fixed'
          document.querySelector('.YJBackTop').style.bottom = '100px'
        } else {
          document.querySelector('.YJBackTop').style.position = 'absolute'
          document.querySelector('.YJBackTop').style.bottom = '600px'
        }
      }
    }
  }

  componentWillUnmount = () => {
    this.setState = (state, callback) => {}
  }

  NavListClick = (item, index) => {
    if (item.name === '官网首页') {
      window.location.href = 'https://www.asfcyy.com'
    } else {
      const { history } = this.props
      history.push(item.router)
    }
    get({ url: 'match/get_match_addr' }).then((res) => {
      if (res.errno === '200') {
        this.setState({
          CityArr: res.data,
          City: res.data[0].province,
        })
        post({
          url: 'match/show_pro_match_scenery_deduplication',
          data: {
            pro: res.data[0].province,
          },
        }).then((res) => {
          if (res.errno === '200') {
            let KeyStart = (this.state.CurrentPage - 1) * this.state.PageSize
            let KeyEnd = this.state.CurrentPage * this.state.PageSize
            let DownloadList = []
            if (KeyEnd <= res.data.length) {
              for (let i = KeyStart; i < KeyEnd; i++) {
                const DownloadListBrr = res.data[i]
                DownloadList.push(DownloadListBrr)
              }
            } else {
              for (let i = KeyStart; i < res.data.length; i++) {
                const DownloadListBrr = res.data[i]
                DownloadList.push(DownloadListBrr)
              }
            }
            this.setState({
              new: '1',
              ProNewsArr: res.data,
              ProNewsBrr: DownloadList,
            })
          } else {
            this.setState({
              ProNewsArr: [],
              new: '2',
            })
          }
        })
      } else {
        this.setState({
          CityArr: [],
          City: '',
        })
      }
    })
    this.setState({
      XQNewsArr: [],
      new: '',
      MoreCity: '',
      SSPage: 0,
    })
  }

  CityClick = (item, index) => {
    this.setState({ City: '' })
    post({
      url: 'match/show_pro_match_scenery_deduplication',
      data: {
        pro: item.province,
      },
    }).then((res) => {
      if (res.errno === '200') {
        let KeyStart = (this.state.CurrentPage - 1) * this.state.PageSize
        let KeyEnd = this.state.CurrentPage * this.state.PageSize
        let DownloadList = []
        if (KeyEnd <= res.data.length) {
          for (let i = KeyStart; i < KeyEnd; i++) {
            const DownloadListBrr = res.data[i]
            DownloadList.push(DownloadListBrr)
          }
        } else {
          for (let i = KeyStart; i < res.data.length; i++) {
            const DownloadListBrr = res.data[i]
            DownloadList.push(DownloadListBrr)
          }
        }
        this.setState({
          new: '1',
          ProNewsArr: res.data,
          ProNewsBrr: DownloadList,
          City: item.province,
        })
      } else {
        this.setState({
          ProNewsArr: [],
          new: '2',
          City: item.province,
        })
      }
    })
  }

  ProCurrentPage(CurrentPage) {
    const KeyStart = (CurrentPage - 1) * this.state.PageSize
    const KeyEnd = CurrentPage * this.state.PageSize
    const DownloadList = []
    if (KeyEnd <= this.state.ProNewsArr.length) {
      for (let i = KeyStart; i < KeyEnd; i++) {
        const DownloadBList = this.state.ProNewsArr[i]
        DownloadList.push(DownloadBList)
      }
    } else {
      for (let i = KeyStart; i < this.state.ProNewsArr.length; i++) {
        const DownloadBList = this.state.ProNewsArr[i]
        DownloadList.push(DownloadBList)
      }
    }
    this.setState({
      ProNewsBrr: DownloadList,
    })
  }

  MoreCity() {
    this.setState({
      MoreCity: 'sb',
    })
  }

  ProNewsClick = (item, index) => {
    if (item.is_pdf && item.is_pdf === 1) {
      get({ url: 'match/show_pro_match_scenery_info/' + item.id }).then(
        (res) => {
          if (res.errno === '200') {
            let data = res.data[0]
            window.open(data.content)
          }
        }
      )
    } else {
      this.setState({ NewContent: '', SSPage: 1 })
      const { history } = this.props
      history.push('/ss?' + item.id)
      get({ url: 'match/show_pro_match_scenery_info/' + item.id }).then(
        (res) => {
          if (res.errno === '200') {
            let data = res.data[0]
            this.setState({
              NewContent: data.content,
              title: data.title,
              Img: data.image_url,
            })
          } else {
            this.setState({
              NewContent: '',
              title: '',
              Img: '',
            })
          }
        }
      )

      post({
        url: 'match/show_pro_match_scenery_deduplication',
        data: {
          pro: item.province,
        },
      }).then((res) => {
        if (res.errno === '200') {
          let dsb = function () {
            for (let i = 0; i < res.data.length; i++) {
              let a = res.data[i].id
              if (a === item.id) {
                return i
              }
            }
          }
          res.data.splice(dsb(), 1)
          this.setState({
            XQNewsArr: res.data,
            newIndex: dsb(),
          })
        }
      })
    }
  }

  SSBack() {
    const { history } = this.props
    history.push('/ss')
    this.setState({
      XQNewsArr: [],
      SSPage: 0,
    })
  }

  BackTop = () => {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'smooth',
    })
  }

  //提示弹窗
  ChildBackTip = (event) => {
    if (event === 'CrossOut') {
      this.setState({
        PopUp: '',
      })
    }
  }

  render() {
    return (
      <div className={'Home'}>
        {/*菜单*/}
        <div
          className={'HomeNavTopBox'}
          style={{ position: 'relative', background: '#00479D' }}
        >
          <div className={'NavTopBox'}>
            <div className={'HomeLogoBox'}>
              <img
                className={'HomeLogo'}
                src="http://oss.asfcyy.com/richTextImage/616aeb76dee911ee9dc800163e3521a2.png"
                alt=""
              />
            </div>
            <div className={'NavTop clearfix'}>
              {NavArr.map((item, index) => (
                <div
                  className={'NavTopList'}
                  key={index}
                  onClick={() => this.NavListClick(item, index)}
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/*顶头图*/}
        <div className={'SSTopImgBox'}>
          <img
            src="https://oss.asfcyy.com/richTextImage/2e63b1749ad311f19dcd00163e3521a2.jpg"
            alt=""
            style={{ top: '-77%' }}
          />
        </div>

        {/*列表*/}
        {this.state.SSPage === 0 && (
          <div className={'SSBox clearfix'}>
            {/*年份选择*/}
            <div className={'YearBox scrollBarTwo'} style={{ maxHeight: 800 }}>
              {this.state.CityArr.map((item, index) => (
                <div key={index}>
                  {index < 14 && this.state.MoreCity === '' && (
                    <div
                      className={'YearList'}
                      onClick={() => this.CityClick(item, index)}
                      style={
                        this.state.City === item.province
                          ? { color: '#00479D' }
                          : {}
                      }
                    >
                      <div
                        className={'YearListIco'}
                        style={
                          this.state.City === item.province
                            ? { display: 'block' }
                            : { display: 'none' }
                        }
                      >
                        {' '}
                      </div>
                      {item.province}
                    </div>
                  )}
                  {this.state.MoreCity !== '' && (
                    <div
                      className={'YearList'}
                      onClick={() => this.CityClick(item, index)}
                      style={
                        this.state.City === item.province
                          ? { color: '#00479D' }
                          : {}
                      }
                    >
                      <div
                        className={'YearListIco'}
                        style={
                          this.state.City === item.province
                            ? { display: 'block' }
                            : { display: 'none' }
                        }
                      >
                        {' '}
                      </div>
                      {item.province}
                    </div>
                  )}
                </div>
              ))}
              {this.state.CityArr.length > 14 && this.state.MoreCity === '' && (
                <div
                  className={'YearList'}
                  style={{ fontSize: 22, color: '#00479D' }}
                  onClick={this.MoreCity.bind(this)}
                >
                  ...
                </div>
              )}
            </div>
            {/*国赛资讯*/}
            <div className={'GSZXBox'} style={{ marginTop: 37 }}>
              <div className={'GSZXTit'} style={{ marginBottom: 10 }}>
                省赛一览
              </div>
              <div className={'GSZXBor'}> </div>
              <div
                className={'GSZXMain'}
                style={{ minHeight: 692, marginBottom: 60 }}
              >
                {this.state.new === '1' && (
                  <div>
                    {this.state.ProNewsBrr.map((item, index) => (
                      <div
                        className={'GSZXMainList'}
                        key={index}
                        onClick={() => this.ProNewsClick(item, index)}
                      >
                        <div
                          className={'GSZXMainW Ellipsis'}
                          title={item.title}
                        >
                          {item.title}
                        </div>
                        <div className={'GSZXMainTime'}>
                          {item.rank_time === ''
                            ? this.state.Year + ' / 03 / 16'
                            : item.rank_time.split('-').join(' / ')}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {this.state.new === '2' && (
                  <div className={'GSZXMainList'} style={{ cursor: 'unset' }}>
                    <div className={'GSZXMainW Ellipsis'}>暂无数据。</div>
                  </div>
                )}
              </div>
              {this.state.ProNewsArr.length !== 0 && (
                <Pagination
                  TotalSize={this.state.ProNewsArr.length}
                  PageSize={this.state.PageSize}
                  pageCallbackFn={this.ProCurrentPage.bind(this)}
                />
              )}
            </div>
          </div>
        )}

        {/*详情*/}
        {this.state.SSPage !== 0 && (
          <div className={'GSXQBox'}>
            <div className={'GSXQTit'}>
              首页 /{' '}
              <span
                style={{ cursor: 'pointer' }}
                onClick={this.SSBack.bind(this)}
              >
                省赛一览
              </span>{' '}
              / 省赛详情
            </div>
            <div>
              <div className={'SSXQMain'}>
                <div
                  dangerouslySetInnerHTML={{ __html: this.state.NewContent }}
                />
              </div>
              <div className={'SSXQMoreBox'}>
                <div className={'SSXQMoreTit'}>更多资讯</div>
                {this.state.XQNewsArr.length !== 0 && (
                  <div>
                    {this.state.XQNewsArr.map((item, index) => (
                      <div key={index}>
                        {index < 3 && (
                          <div
                            className={'SSXQMore'}
                            onClick={() => this.ProNewsClick(item, index)}
                          >
                            {item.title}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {this.state.XQNewsArr.length === 0 && (
                  <div className={'SSXQMore'}>暂无。</div>
                )}
              </div>
            </div>
          </div>
        )}

        {this.state.SSPage !== 0 && (
          <div
            className={'YJBackTop'}
            style={{ display: 'none' }}
            onClick={this.BackTop.bind(this)}
          >
            <div className={'YJBackTopIco'}> </div>
            <div className={'YJBackTopW'}>飞到顶部</div>
          </div>
        )}

        <Footer />
        {this.state.PopUp === '提示弹窗' && (
          <PopUp
            ChildBackClick={this.ChildBackTip.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'Yes'}
          />
        )}
      </div>
    )
  }
}

export default GS
